import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { refreshActiveContext } from '../store/activeContext/actions';

/**
 * Fires {@code refreshActiveContext} whenever the tab regains visibility, so
 * the org switcher and Global-View eligibility flag pick up server-side
 * changes (new membership, revoked aggregate-view permission) without
 * requiring a logout. The saga already throttles repeat calls to one every
 * 5 seconds, so we don't need a cooldown here.
 *
 * <p>Skips the dispatch when there's no auth token — the login page mounts
 * this hook too and shouldn't ping a protected endpoint anonymously.
 */
const useActiveContextRefresh = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;
      if (!localStorage.getItem('token')) return;
      dispatch(refreshActiveContext());
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleVisibilityChange);
    };
  }, [dispatch]);
};

export default useActiveContextRefresh;
